import { ClassId, EnrollmentPackageId, PersonId, GroupId, PlanTypeId } from "../primaryKeys/PrimaryKey";
import { Nullable } from '../../custom/Nullable';
import { ApiDate } from "../../custom/ApiDate";
import { HarmonyProductGroup } from '../../thirdParty/harmony/HarmonyProductGroup';
import { EnrollmentAgentType } from "../../enums/EnrollmentAgentType";
import { PackageType } from '../../enums/PackageType';

/** Named after a DTO of the same name on the back end. */
export interface Package {
    enrollmentPackageId: EnrollmentPackageId,
    personId: PersonId,
    personName: string,
    startDate: ApiDate,
    endDate: ApiDate,
    approvedDate: Nullable<ApiDate>,
    isApproved: boolean,
    completionDate: Nullable<ApiDate>,
    lastCompletedStepNumber: number,
    packageTypeId: PackageType, // ToDo: Map to an enum
    packageTypeName: string,
    groupId: GroupId,
    groupLogoFileName: Nullable<string>;
    dateCurrentPlanYearIsEffective: ApiDate,
    dateOfHire: ApiDate,
    dateOfQualifyingEvent: ApiDate,
    qualifyingEventTypeId: number, // ToDo: Map to an enum
    spouseSignaturePathData: Nullable<string>,
    subscriberSignaturePathData: Nullable<string>,
    enrollmentAssistantId: Nullable<string>,
    enrollmentAssistantName: Nullable<string>,
    classId: ClassId,
    residentCity: Nullable<string>,
    residentState: Nullable<string>,
    enrollmentTypeId: Nullable<EnrollmentAgentType>,
    steps: readonly PackageStep[],
    planTypes: readonly AvailablePlanType[],
    emailAddress: Nullable<string>,
    aidedByEnrollmentAssistantId: Nullable<string>,
    aidedByEnrollmentAssistantName: Nullable<string>,
    aidedByEnrollmentTypeId: Nullable<EnrollmentAgentType>,
    aidedByEnrollmentAssistantUserId: Nullable<number>,
    hideEmployeeContributionInEnrollment: boolean,
    hideEmployerContributionInEnrollment: boolean
}

export interface PackageStep {
    name: string,
    number: number,
    progress: number,
    relatedEntityId: Nullable<PlanTypeId>,
    harmonyProductGroup: Nullable<HarmonyProductGroup>,
    type: PackageStepType,
    enrollmentContent: string
}

export interface AvailablePlanType {
    listPosition: number,
    planTypeId: PlanTypeId,
    planTypeName: string,
    planTypeDisplayName: string,
    planTypeShortName: string,
    needsInsurability: boolean
}

export enum PackageStepType {
    Welcome = "Welcome",
    EmployeeInfo = "EmployeeInfo",
    Dependents = "Dependents",
    PlanType = "PlanType",
    Insurability = "Insurability",
    Summary = "Summary",
    Finish = "Finish",
    DocumentUpload = "DocumentUpload",
}